<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>统计管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/calculateProfit')">利润统计</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns">
      </ul>
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
        <el-form-item label='代理手机号'>
            <el-input
              v-model="filters.userPhone"
              placeholder="代理手机号"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="查询时间">
            <el-form-item prop="startTime">
              <el-date-picker
                type="date"
                :clearable=false
                placeholder="选择开始日期"
                v-model="filters.startTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
            <span style="display: inline-block;margin-right: 9px;">-</span>
            <el-form-item prop="endTime">
              <el-date-picker
                type="date"
                placeholder="选择结束日期"
                v-model="filters.endTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>

          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch()"
            >统计</el-button>

            <el-button
              style="margin-left:10px"
              @click="excelOut(1)"
              type="primary"
              size="small"
            >导出</el-button>

            <el-form-item label="代理类型">
              <el-select clearable v-model="filters.roleType" placeholder="请选择">
                <el-option label="无" value="-1"></el-option>
                <el-option label="康减系列vip会员" value="-0.5"></el-option>
                <el-option label="康减系列高级会员" value="-0.4"></el-option>
                <el-option label="康减系列荣誉会员" value="-0.3"></el-option>

                <el-option label="康减系列市代" value="1.1"></el-option>
                <el-option label="康减系列省代" value="2.1"></el-option>
                <el-option label="康减系列CEO" value="3.1"></el-option>

                <el-option label="VIP门店" value="0"></el-option>
                <el-option label="联盟店" value="1"></el-option>
                <el-option label="优秀联盟店" value="1.05"></el-option>
                <el-option label="市代" value="2"></el-option>
                <el-option label="省代" value="3"></el-option>
                <el-option label="CEO" value="4"></el-option>
                <el-option label="总经销商" value="5"></el-option>
                <el-option label="销售公司" value="6"></el-option>

                <el-option label="合伙人" value="2.2"></el-option>
                <el-option label="董事" value="4.2"></el-option>

                <el-option label="经销商" value="4.8"></el-option>
                <el-option label="区域总监" value="5.1"></el-option>
                <el-option label="城市加盟商" value="5.2"></el-option>
              </el-select>
            </el-form-item>

            <el-button
              style="margin-left:10px"
              @click="excelOut(2)"
              type="primary"
              size="small"
            >导出全部</el-button>

          </el-form-item>

        </el-form>
      </div>

      <div class="contain_body">
        <el-table
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >

          <el-table-column
            prop="order_code"
            label="流水号"
          >
          </el-table-column>

          <el-table-column
            prop="info_money"
            label="销售金额"
          >
          </el-table-column>

          <el-table-column
            prop="buy_money"
            label="采购金额"
          >
          </el-table-column>

          <el-table-column
            prop="create_time_info"
            label="交易时间"
          >
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>

  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import { dateFunc } from "../../dateFunc";
import API from "../../api/api_user";
var _ = require("lodash");
export default {
  name: "judgeList",
  created() {
  },
  data() {
    return {
      picList:[],
      subListVisible:false,
      dialogAddVisible:false,
      filters: {
        userPhone:null,
        roleType: null,
        endTime: null,
        startTime:new Date(new Date() - 1000 * 60 * 60 * 24 * 30),
        status:null
      },
      page_num: 1,
      keywords: "",
      pickerOptions1: 1,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableDetailData:[],
      detailListLoading:false,
      tableHeight:null,
      page_num1: 1,
      total_num1: 0,
      total_page1: 0,
      page_size1: 10,
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    excelOut(type) {
      var that = this;
      if(type == 1){
        var url =
        "/manager/user/pc/get_money_record_list_excel?token=" +
        localStorage.getItem("api_token");
        if (that.filters.userPhone) {
          url = url + "&telephone=" + that.filters.userPhone;
        }else
          {
            that.$message.error({
              showClose: true,
              message: '请输入代理手机号',
              duration: 2000
            });
            return;
          }

        if (that.filters.startTime) {
          url = url + "&startTime=" + that.filters.startTime.getTime();
        } else {
          that.$message.error({
            showClose: true,
            message: '请选择开始时间',
            duration: 2000
          });
          return;
        }
        if (that.filters.endTime) {
          url = url + "&endTime=" + that.filters.endTime.getTime();
        } else
        {
          that.$message.error({
            showClose: true,
            message: '请选择结束时间',
            duration: 2000
          });
          return;
        }
      top.location.href = url;
      }else if(type == 2){
        var url =
        "/manager/user/pc/get_money_count_excel?token=" +
        localStorage.getItem("api_token");
        if(that.filters.roleType){
          url = url+"&roleType="+ that.filters.roleType
        }
        if (that.filters.startTime) {
          url = url + "&startTime=" + that.filters.startTime.getTime();
        } else {
          that.$message.error({
            showClose: true,
            message: '请选择开始时间',
            duration: 2000
          });
          return;
        }
        if (that.filters.endTime) {
          url = url + "&endTime=" + that.filters.endTime.getTime();
        } else
        {
          that.$message.error({
            showClose: true,
            message: '请选择结束时间',
            duration: 2000
          });
          return;
        }
      top.location.href = url;
      }
    },
     addPostDialog() {
      this.$router.push({
        path: "/addCourse"
      });
    },
    editPostDialog(row) {
      this.$router.push({
        path: "/addCourse",
        query: {
          good: row
        }
      });
    },
    upHouseStatus(row) {
      this.$router.push({ path: "/cardMp3List", query: { userId: row.id } });
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    showSecond(row){
      this.picList = row.content.split(',');
      console.info(this.picList);
      this.dialogAddVisible = true;
    },
    search() {
      let that = this;
      let params = {
        token: localStorage.getItem("api_token"),
        page_num: that.page_num,
        page_size: that.page_size
      };
      if (that.filters.userPhone) {
        params.telephone = that.filters.userPhone;
      }else
      {
        that.$message.error({
          showClose: true,
          message: '请输入代理手机号',
          duration: 2000
        });
        return;
      }
      if (that.filters.startTime) {
        params.startTime = that.filters.startTime.getTime();
      } else
      {
        that.$message.error({
          showClose: true,
          message: '请选择开始时间',
          duration: 2000
        });
        return;
      }
      if (that.filters.endTime) {
        params.endTime = that.filters.endTime.getTime();
      } else
      {
        that.$message.error({
          showClose: true,
          message: '请选择结束时间',
          duration: 2000
        });
        return;
      }
      that.loading = true;
      API.get_money_record_list(params)
        .then(
          function(result) {
            that.loading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              that.tableData = result.result.list;
            }else if(result.key == 1010){
              that.tableData =[];
              that.$message.error({
              showClose: true,
              message: result.message.toString(),
              duration: 2000
            });
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>
.shop-pic{
    width: 100%;
    /* display: flex;
    flex-wrap: wrap;
    justify-content: space-around; */
    height: 80vh;
    overflow: hidden;
    overflow-y: auto;
}
.shop-pic img {
  /* width: 49%; */
  width: 100%;
  height: auto;
  margin: 0 auto;
}
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/calculateProfit.vue